import { render, staticRenderFns } from "./TabConceptualizacion.vue?vue&type=template&id=d5d029ba&scoped=true&"
import script from "./TabConceptualizacion.vue?vue&type=script&lang=js&"
export * from "./TabConceptualizacion.vue?vue&type=script&lang=js&"
import style0 from "./TabConceptualizacion.vue?vue&type=style&index=0&id=d5d029ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d029ba",
  null
  
)

export default component.exports